<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.2、发动机转速</h3>

        <!-- ECharts 柱状图容器 -->
        <div ref="speedChart" class="chart-container" style="height: 280px;margin-top: 15px;"></div>
        <div class="table-caption">图表2</div>
        <!-- 横向多列表格（完全匹配截图） -->
        <el-table :data="tableData" border style="width: 100%; " :cell-class-name="cellStyle">
            <!-- 表头合并：转速列 -->
            <el-table-column label="转速(r/min)" align="center">
                <template slot-scope="scope">
                    {{ scope.row.speedLabel }}
                </template>
            </el-table-column>
            <!-- 时间列 -->
            <el-table-column label="时间(小时)" prop="time" align="center" />
            <!-- 百分比列 -->
            <el-table-column label="百分比(%)" prop="percent" align="center" />
        </el-table>
        <div class="table-caption">数据表2</div>

        <!-- 说明文本 -->
        <div class="note">
            <p>说明：</p>
            <p>采集段内的最高转速为2310.5r/min 。</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "barchart",

    data() {
        return {

            tableData: [
                {
                    speedLabel: '≤700',
                    time: 9.16,
                    percent: 35.77,
                    isGreen: false
                },
                {
                    speedLabel: '≤800',
                    time: 4.42,
                    percent: 17.26,
                    isGreen: false
                },
                {
                    speedLabel: '≤900',
                    time: 0.56,
                    percent: 2.17,
                    isGreen: false
                },
                {
                    speedLabel: '≤1000',
                    time: 0.88,
                    percent: 3.45,
                    isGreen: false
                },
                {
                    speedLabel: '≤1100',
                    time: 1.24,
                    percent: 4.85,
                    isGreen: true
                },
                {
                    speedLabel: '≤1200',
                    time: 1.63,
                    percent: 6.38,
                    isGreen: true
                },
                {
                    speedLabel: '≤1300',
                    time: 1.75,
                    percent: 6.82,
                    isGreen: true
                },
                {
                    speedLabel: '≤1400',
                    time: 1.25,
                    percent: 4.86,
                    isGreen: true
                },
                {
                    speedLabel: '≤1500',
                    time: 1.77,
                    percent: 6.89,
                    isGreen: true
                },
                {
                    speedLabel: '≤1600',
                    time: 1.47,
                    percent: 5.75,
                    isGreen: true
                },
                {
                    speedLabel: '≤1700',
                    time: 0.44,
                    percent: 1.74,
                    isGreen: false
                },
                {
                    speedLabel: '≤1800',
                    time: 0.12,
                    percent: 0.48,
                    isGreen: false
                },
                {
                    speedLabel: '≤1900',
                    time: 0.04,
                    percent: 0.18,
                    isGreen: false
                },
                {
                    speedLabel: '≤2000',
                    time: 0.02,
                    percent: 0.08,
                    isGreen: false
                },
                {
                    speedLabel: '≤2200',
                    time: 0.01,
                    percent: 0.02,
                    isGreen: false
                },
                {
                    speedLabel: '≤2400',
                    time: 0,
                    percent: 0,
                    isGreen: false
                },
                {
                    speedLabel: '>2400',
                    time: 0,
                    percent: 0,
                    isGreen: false
                },
                {
                    speedLabel: '累计',
                    time: 25.6,
                    percent: 100,
                    isGreen: false
                }
            ],
            // 标记需要绿色背景的列（转速区间）
            greenColumns: ['speed1100', 'speed1200', 'speed1300', 'speed1400', 'speed1500', 'speed1600']
        };
    },
    mounted() {
        this.initSpeedChart();
    },
    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (row.isGreen) {
                return 'green-column';
            } else {
                if (columnIndex === 0) {
                    return 'cell-header';
                }
            }

        },
        // 合并单元格方法
        initSpeedChart() {
            const chartDom = this.$refs.speedChart;
            const myChart = echarts.init(chartDom);

            // 图表配置
            const option = {
                title: {
                    text: '',
                    left: 'center',

                },
                backgroundColor: '#E2F0FF',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: {
                    left: '3%',

                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                xAxis: {
                    name: '发动机转速(r/min)',
                    nameLocation: 'center',
                    nameGap: 40,
                    type: 'category',
                    data: ["≤50", "500", "700", "900", "950", "1000", "1100", "1200",
                        "1300", "1400", "1500", "1600", "1700", "1800", "1900",
                        "2000", "2200", "2400", ">2400"],
                    axisLabel: {
                        rotate: 45,
                        interval: 0
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '百分比(%)'
                },
                series: [
                    {
                        data: [3.1, 0.21, 35.77, 17.26, 2.17, 3.45, 4.85, 6.38,
                            6.82, 4.86, 6.89, 5.75, 1.74, 0.48, 0.18, 0.08,
                            0.02, 0, 0],
                        type: 'bar',

                        label: {
                            show: true,
                            position: 'top'
                        },
                        itemStyle: {
                            color: function (params) {
                                // 700区间用深蓝色，其他用绿色/蓝色
                                return params.dataIndex === 2 ? '#3E79B9' :
                                    params.dataIndex === 3 ? '#6AA5D7' :
                                        params.dataIndex === 12 ? '#6AA5D7' : '#5BC78E';
                            }

                        }
                    }
                ]
            };

            myChart.setOption(option);

            // 监听窗口 resize，自适应图表
            window.addEventListener('resize', () => {
                myChart.resize();
            });
        }
    }
};
</script>
<style scoped>
.chart-container {
    width: 100%;
    background: #f9fafc;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}

::v-deep .el-table .green-cell {
    background-color: #dff0d8 !important;
    /* 浅绿色背景 */
}

::v-deep .el-table .cell {
    padding: 0px 0;
    font-size: 8pt !important;

}

::v-deep .green-column {
    background-color: #dff0d8 !important;
    /* 浅绿色背景 */
}

::v-deep .cell-header-warning {
    background: #dba8a8 !important;
    color: #000 !important;
    border-bottom: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
}

::v-deep .el-table th.el-table__cell>.cell {
    padding-left: 4px !important;
    padding-right: 4px !important;
}

.table-caption {
    text-align: center;
    margin: 8px 0;
    font-weight: 500;
}
</style>